export default __webpack_public_path__ + "static/media/ManageEvents.fe5a8c9d.png";